<template>
  <BoxCard class="mt-10">
    <template #header>Session resources</template>
    <template #content>
      <ul role="list" class="divide-y divide-gray-200">
        <li
          class="py-2 flex items-center justify-between text-sm"
          v-for="(file, index) in $page.props.session.files"
          :key="`file-${index}`"
        >
          <div class="w-0 flex-1 flex items-center">
            <PaperClipIcon class="text-gray-500 flex-shrink-0 h-5 w-5" aria-hidden="true" />
            <a
              target="_blank"
              :href="file.file_url"
              :download="file.name"
              class="cursor-pointer ml-2 flex-1 w-0 truncate"
            >
              {{ file.name }}
            </a>
          </div>
        </li>
      </ul>
    </template>
  </BoxCard>
</template>

<script>
import { PaperClipIcon } from '@heroicons/vue/solid';
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'SessionFiles',
  components: {
    BoxCard,
    PaperClipIcon,
  },
};
</script>

<style scoped></style>
